import { Building2, ChevronDown } from 'lucide-react';
import { useGym } from '../../contexts/GymContext';

const GymSelectorTrigger = ({ onClick }) => {
  const { selectedGym } = useGym();

  if (!selectedGym) return null;

  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-2 px-4 py-2.5 bg-white hover:bg-teal-50 border-2 border-slate-900 rounded-lg shadow-retro hover:shadow-retro-hover transition-all touch-manipulation group"
      aria-label="Select gym"
    >
      <Building2 className="w-5 h-5 text-purple-600 flex-shrink-0" />

      <div className="flex flex-col items-start min-w-0">
        <span className="text-sm font-bold text-slate-900 truncate max-w-[200px] sm:max-w-xs">
          {selectedGym.name}
        </span>
        {(selectedGym.city || selectedGym.state) && (
          <span className="text-xs text-slate-600 truncate max-w-[200px] sm:max-w-xs">
            {selectedGym.city}{selectedGym.city && selectedGym.state ? ', ' : ''}{selectedGym.state}
          </span>
        )}
      </div>

      <ChevronDown className="w-5 h-5 text-teal-500 group-hover:text-teal-600 transition-colors flex-shrink-0" />
    </button>
  );
};

export default GymSelectorTrigger;
